<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col cols="12" md="6">
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('career.openPositions.title') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col  class="display-1">
            {{ $t('career.openPositions.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            <v-alert
              v-for="(item,index) in openPositions"
              :key="index"
              :color="item.color"
              dark
              :icon="item.icon"
              class="alert-icon mb-3"
              border="left">
              <v-row align="center">
                <v-col class="grow">
                  {{ $t('career.openPositions.' + item.position)}}
                </v-col>
                <v-col class="py-0 shrink">
                  <v-btn outlined small style="height:48px"
                    @click="loadPage(item.component)">
                    {{ $t('common.moreInfo.01')}}<br>
                    {{ $t('common.moreInfo.02')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <!-- <v-alert
              type="info"
              icon="mdi-database"
              class="alert-icon"
              border="left">
                <v-col>{{ $t('career.openPositions.noOpenPosition')}}</v-col>
            </v-alert> -->
            <div class="mt-6">{{ $t('career.openPositions.applyToDataBase')}}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            {{ $t('career.openPositions.text')}}<br>
            <v-list>
              <v-list-item
                v-for="(item,index) in 7"
                :key="index"
                dense>
                <v-icon size="8" class="mr-4">mdi-checkbox-blank-circle</v-icon>  {{ $t('career.openPositions.param.0' + (index + 1)) }}
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="align-center d-flex">
        <v-img
          src="@/assets/img/rubin-img-10-crop.png"
          max-width="500"
          contain
          class="ml-12 mr-auto"
          style="width: calc(100% - 48px);">
        </v-img>
        <img src="@/assets/cert-familyfriendly-2020.png" loading="lazy" alt="Családbarát munkahely 2020" style="max-height:154px;position:absolute" class="mr-4">
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'OpenPositions',
    extends: DataComponentBase,

    data: () => ({
      openPositions: [
        // java developer
        // {
        //   position: 'javaDeveloper',
        //   suffix: 'Java_SWfejleszto',
        //   icon: 'mdi-account-cowboy-hat-outline',
        //   color: 'grey darken-4',
        // },
        // project assistant
        // {
        //   position: 'projectAssistant',
        //   suffix: 'Projektasszisztens',
        //   icon: 'mdi-account-outline',
        //   color: 'success',
        // },
        // installation manager
        // {
        //   component: 'InstallationManager',
        //   position: 'installationManager',
        //   suffix: 'Telepitesvezeto',
        //   icon: 'mdi-account-hard-hat-outline',
        //   color: 'blue',
        // },
        // tester
        // {
        //   position: 'softwareTester',
        //   suffix: 'Teszteloi',
        //   icon: 'mdi-account-cowboy-hat-outline',
        //   color: 'pink',
        // },
        // system&workflow operation support staff member
        // {
        //   component: 'SystemAndWorkflowOperationSupportStaffMember',
        //   position: 'systemAndWorkflowOperationSupportStaffMember',
        //   suffix: 'System&WorkflowUzemeltetesTamogatasimunkatars',
        //   icon: 'mdi-account-cowboy-hat-outline',
        //   color: 'grey',
        // },
      ],

    }),

    computed: {
      mini() {
        if (this.computedHeight < 800) {
          return true
        } else {
          return false
        }
      },
    },

    methods: {
    },
  }
</script>
